var _path, _path2, _ellipse, _path3, _ellipse2, _path4, _ellipse3, _path5, _ellipse4, _path6, _ellipse5, _path7, _ellipse6, _path8, _ellipse7, _path9, _ellipse8, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare84B = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 62 62",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17 19.5a2.5 2.5 0 0 1 2.5-2.5h23a2.5 2.5 0 0 1 2.5 2.5v23a2.5 2.5 0 0 1-2.5 2.5h-23a2.5 2.5 0 0 1-2.5-2.5v-23Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 19.5a2.5 2.5 0 0 1 2.5-2.5h23a2.5 2.5 0 0 1 2.5 2.5v23a2.5 2.5 0 0 1-2.5 2.5h-23a2.5 2.5 0 0 1-2.5-2.5v-23Z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 9,
  cy: 23,
  fill: "#464D57",
  rx: 5,
  ry: 6
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M10 29H9c-2.761 0-5-2.686-5-6s2.239-6 5-6h1"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 9,
  cy: 39,
  fill: "#464D57",
  rx: 5,
  ry: 6
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M10 45H9c-2.761 0-5-2.686-5-6s2.239-6 5-6h1"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 53,
  cy: 23,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-180 53 23)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M52 17h1c2.761 0 5 2.686 5 6s-2.239 6-5 6h-1"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 53,
  cy: 39,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-180 53 39)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M52 33h1c2.761 0 5 2.686 5 6s-2.239 6-5 6h-1"
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 23,
  cy: 9,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(90 23 9)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M17 10V9c0-2.761 2.686-5 6-5s6 2.239 6 5v1"
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 39,
  cy: 9,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(90 39 9)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M33 10V9c0-2.761 2.686-5 6-5s6 2.239 6 5v1"
})), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 23,
  cy: 53,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-90 23 53)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M29 52v1c0 2.761-2.686 5-6 5s-6-2.239-6-5v-1"
})), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 39,
  cy: 53,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-90 39 53)"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M45 52v1c0 2.761-2.686 5-6 5s-6-2.239-6-5v-1"
})));
SvgSquare84B.viewBox = '0 0 62 62';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare84B);
export default ForwardRef;